import { campxLogoSquare } from '../../../assets/images'
import { isDevelopment } from '../../../constants'
import {
  campxSquareSmall,
  commuteSmall,
  enrollSmall,
  examsSmall,
  hostelSmall,
  paySmall,
  peopleSmall,
} from './assets'

const origins = {
  admin: {
    dev: 'https://admin.campx.dev',
    prod: 'https://admin.campx.in',
  },
  enroll: {
    dev: 'https://enroll.campx.dev',
    prod: 'https://enroll.campx.in',
  },
  payments: {
    dev: 'https://payments.campx.dev',
    prod: 'https://payments.campx.in',
  },
  ums: {
    dev: 'https://ums.campx.dev',
    prod: 'https://ums.campx.in',
  },
  exams: {
    dev: 'https://exams.campx.dev',
    prod: 'https://exams.campx.in',
  },
  people: {
    dev: 'https://people.campx.dev',
    prod: 'https://people.campx.in',
  },
  hostel: {
    dev: 'https://hostel.campx.dev',
    prod: 'https://hostel.campx.in',
  },
  commute: {
    dev: 'https://commute.campx.dev',
    prod: 'https://commute.campx.in',
  },
}

export const applications = [
  {
    title: 'Admin',
    path: isDevelopment ? origins.admin.dev : origins.admin.prod,
    icon: campxLogoSquare,
    key: 'admin',
    domainName: 'admin',
    description: 'Manage Complete Campus Root Configuration',
  },

  {
    title: 'EnrollX',
    key: 'enroll_x',
    domainName: 'enroll',
    path: isDevelopment ? origins.enroll.dev : origins.enroll.prod,
    icon: enrollSmall,
    description: 'Manage Admissions in the Campus',
  },
  {
    title: 'PayX',
    key: 'payments',
    domainName: 'payments',
    path: isDevelopment ? origins.payments.dev : origins.payments.prod,
    icon: paySmall,
    description: 'Manage Payments in the Campus',
  },
  {
    title: 'CollegeX',
    path: isDevelopment ? origins.ums.dev : origins.ums.prod,
    icon: campxSquareSmall,
    key: 'square',
    domainName: 'ums',
    description: 'Manage Complete Campus Activities',
  },
  {
    title: 'ExamX',
    key: 'exams',
    domainName: 'exams',
    path: isDevelopment ? origins.exams.dev : origins.exams.prod,
    icon: examsSmall,
    description: 'Manage all Examinations in the Campus',
  },
  {
    title: 'PeopleX',
    key: 'hrms',
    domainName: 'people',
    path: isDevelopment ? origins.people.dev : origins.people.prod,
    icon: peopleSmall,
    description: 'Manage People in the Campus',
  },
  {
    title: 'HostelX',
    key: 'hostels',
    domainName: 'hostel',
    path: isDevelopment ? origins.hostel.dev : origins.hostel.prod,
    icon: hostelSmall,
    description: 'Manage Hostels in the Campus',
  },
  {
    title: 'CommuteX',
    key: 'commute_x',
    domainName: 'commute',
    path: isDevelopment ? origins.commute.dev : origins.commute.prod,
    icon: commuteSmall,
    description: 'Manage Commute in the Campus',
  },
]
